
import { Brick, registerBrick, CloudObject, User, Auth, WorkflowObjectState } from 'olympe';
import { getLogger } from '@olympeio/core';
import {
    canAcceptOrReject, getCurrentWorkflow, BCP_WORKFLOW_STATES, getLatestQualityApprover, canDelete,
    canRejectDisable
} from '../../../common/section_bcp/BcpWorkflowAuthorizations';
import { getApplicationContext } from '../../../common/utils/Context.js';

export default class GetStatusOfDifferentControls extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} selectedBCP
     * @param {function(boolean)} setDisableAcceptButton
     * @param {function(boolean)} setToShowDatePicker
     * @param {function(boolean)} setShowBpPmRejectionDropDown
     * @param {function(boolean)} setShowQARejectionDropDown
     * @param {function(boolean)} setAnyRowSelectedOrNot
     * @param {function(boolean)} setDisableUpdateButton
     */
    async update($, [selectedBCP], [setDisableAcceptButton, setToShowDatePicker,
        setShowBpPmRejectionDropDown, setShowQARejectionDropDown, setDisableRejectButton,
        setDisableDeleteButton, setToShowPMMessage, setAnyRowSelectedOrNot, setDisableUpdateButton]) {
        const logger = getLogger('get Status of Accept Button');
        logger.info(":: selectedBCP ::", selectedBCP)
        const applicationContext = getApplicationContext($);
        if (selectedBCP?.length === 0 || null === selectedBCP) {
            logger.info(":: length of selected value is zero")
            setDisableAcceptButton(true)
            setDisableRejectButton(true)
            setDisableDeleteButton(true)
            setAnyRowSelectedOrNot(true)
            setDisableUpdateButton(true)
        } else {
            setAnyRowSelectedOrNot(false)
            let acceptanceArray = Array(selectedBCP?.length).fill()
            let bcpCurrentStatusArray = [] //Array(selectedBCP?.length).fill()
            let deleteStatusArray = []
            const isAdmin = applicationContext.get('isadmin');
            logger.info(":::isAdmin:::", isAdmin)
            let qualityRoles = [BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE]
            let qualityRolesForRejection = [BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1, BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2, BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE,
            BCP_WORKFLOW_STATES.WAITING_ON_COMPLETION]
            let bpPmRejectionRolesForRejection = [BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP, BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM]
            let pmApprovalArray = [BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM]

            let adminQualityInFactoryStage2 = [BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1]
            let emailOfUser = "";
            let bcpRequest = {};
            if (Object.entries(selectedBCP).length > 0) {
                for (const [key, value] of Object.entries(selectedBCP)) {
                    logger.info("BCP data:", key, value[0]);
                    emailOfUser = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);
                    bcpRequest = CloudObject.get(value.tag);
                    const currentWorkflowState = await getCurrentWorkflow(value, $)?.get(WorkflowObjectState.stateProp);
                    let latestApproverRole = await getLatestQualityApprover(bcpRequest, getCurrentWorkflow(bcpRequest, $));
                    bcpCurrentStatusArray.push(currentWorkflowState);
                    bcpCurrentStatusArray = bcpCurrentStatusArray?.filter(function (element) {
                        return element !== undefined;
                    });
                    const canAccept = await canAcceptOrReject(isAdmin, emailOfUser, bcpRequest, $);
                    logger.info("canAccept:", canAccept);
                    if (canAccept) {
                        acceptanceArray.push(canAccept)
                    }
                    // whether this request can be delted or not
                    const canUserDeleteRequest = await canDelete(isAdmin, emailOfUser, bcpRequest);
                    if (canDelete) {
                        deleteStatusArray.push(canUserDeleteRequest)
                    }
                    // Whether rejection would be enabled or not                   
                }
                logger.info(":: Acceptance Array 1 ::", acceptanceArray?.filter(element => element))
                logger.info(":: Acceptance Array 3 ::", selectedBCP)
                logger.info(":: bcpCurrentStatusArray ::", bcpCurrentStatusArray)
                logger.info(":: deleteStatusArray ::", deleteStatusArray)
            }
            let disabledAccept;
            if (acceptanceArray?.filter(element => element)?.length === selectedBCP.length) {
                disabledAccept = false
            } else {
                disabledAccept = true
            }
            setDisableAcceptButton(disabledAccept);
            // Check if any of the current status is CTAG, SQA or QA in factory then show the date picker
            let toShowDatePicker = bcpCurrentStatusArray?.filter((element) => {
                return element !== undefined;
            }).some(r => qualityRoles.includes(r))

            let toShowCheckBox = isAdmin ? bcpCurrentStatusArray?.filter((element) => {
                return element !== undefined;
            }).some(r => adminQualityInFactoryStage2.includes(r)) : false
            // To show either both dropdown or only one

            let showQARejectionDropDown = bcpCurrentStatusArray?.filter((element) => {
                return element !== undefined;
            }).some(r => qualityRolesForRejection.includes(r));

            let showBpPMRejectionDropdown = bcpCurrentStatusArray?.filter((element) => {
                return element !== undefined;
            }).some(r => bpPmRejectionRolesForRejection?.includes(r));

            let toShowPMMessage = bcpCurrentStatusArray?.filter((element) => {
                return element !== undefined;
            }).some(r => pmApprovalArray.includes(r));
            //Reject case check for PS
            let isRejectButtonDisabled = await canRejectDisable(isAdmin, emailOfUser, bcpRequest, $)
            let disableRejectButton = bcpCurrentStatusArray?.filter((element) => {
                return element === "Rejected";
            })?.length > 0 || !isRejectButtonDisabled
            let disabledUpdateButton = bcpCurrentStatusArray?.filter((element) => {
                return element === "Rejected";
            })?.length > 0
            let disableRejectButtonOrNot = deleteStatusArray?.filter((element) => {
                return !element
            })?.length > 0

            logger.info(":: toShowCheckBox, showQARejectionCode,showBpPMRejectionDropdown ::",
                toShowCheckBox, showQARejectionDropDown, showBpPMRejectionDropdown)
            setShowBpPmRejectionDropDown(showBpPMRejectionDropdown)
            setShowQARejectionDropDown(showQARejectionDropDown)
            applicationContext.set("toShowCheckBox", toShowCheckBox);
            logger.info(":: toShowDatePicker, disableRejectButton,disabledAccept, disabledButton, toShowPMMessage,disabledUpdateButton ::",
                toShowDatePicker, disableRejectButton, disabledAccept, toShowPMMessage, disabledUpdateButton)

            setDisableRejectButton(disableRejectButton)
            setToShowDatePicker(toShowDatePicker)
            setDisableDeleteButton(disableRejectButtonOrNot)
            setToShowPMMessage(toShowPMMessage)
            setDisableUpdateButton(disabledUpdateButton)
        }
    }
}



registerBrick('019782fc53499e8d92da', GetStatusOfDifferentControls);
